import i18n from 'i18n/config';

export const getSubmitButtonText = (isSection, isSubmit) => {
  if (isSubmit && isSection) {
    return i18n.t('buttons.submitSection');
  }
  if (isSubmit && !isSection) {
    return i18n.t('buttons.submitAssessment');
  }
  if (!isSubmit && isSection) {
    return i18n.t('buttons.startSection');
  }
  return i18n.t('buttons.startAssessment');
};
